// extracted by mini-css-extract-plugin
export default {"root":"input_root__LjSuG","iconWrapper":"input_iconWrapper__yH3Bc","icon":"input_icon__0oVlh","input":"input_input__Z6F94"};